import {React,useEffect} from 'react';
import './DoctorAppointment.css';
import { FaSearch, FaArrowRight, FaCalendarAlt, FaUserMd, FaStar } from 'react-icons/fa';
import doctor from '../../Assets/Banner/doctor.png';
import DoctorCategoryCards from '../CategoryCards/DoctorCategoryCards';

const DoctorAppointment = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
}, []);

  return (
    <div className="doctor-app-container">
      {/* Hero Section */}
      <div className="doctor-hero">
        <div className="hero-content">
          <h1>Find & Book <span>Top Specialists</span> Near You</h1>
          <p className="hero-subtitle">Connect with experienced doctors for in-person or virtual consultations</p>
          
          <div className="hero-stats">
            <div className="stat-item">
              <span className="stat-number">500+</span>
              <span className="stat-label">Specialists</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">24/7</span>
              <span className="stat-label">Availability</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">98%</span>
              <span className="stat-label">Patient Satisfaction</span>
            </div>
          </div>
        </div>
        <div className="hero-image">
          <img src={doctor} alt="Friendly doctor" />
        </div>
      </div>

      {/* Specializations Section */}
      <section className="specializations-section">
        <div className="section-header">
          <h2>Find Doctors By <span>Specialization</span></h2>
          <p>Browse our comprehensive list of medical specialties</p>
        </div>
        
        <div className="specializations-grid">
        <DoctorCategoryCards/>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <div className="section-header">
          <h2>How It <span>Works</span></h2>
          <p>Book an appointment in just 3 simple steps</p>
        </div>
        
        <div className="steps-container">
          <div className="step">
            <div className="step-icon">
              <FaSearch />
            </div>
            <h3>Find Your Doctor</h3>
            <p>Search by specialty, location, or doctor's name</p>
          </div>
          
          <div className="step-connector">
            <div className="connector-line"></div>
            <FaArrowRight className="arrow-icon" />
          </div>
          
          <div className="step">
            <div className="step-icon">
              <FaCalendarAlt />
            </div>
            <h3>Book Appointment</h3>
            <p>Choose from available time slots that work for you</p>
          </div>
          
          <div className="step-connector">
            <div className="connector-line"></div>
            <FaArrowRight className="arrow-icon" />
          </div>
          
          <div className="step">
            <div className="step-icon">
              <FaUserMd />
            </div>
            <h3>Consult Doctor</h3>
            <p>Visit in-person or connect virtually for consultation</p>
          </div>
        </div>
      </section>

      {/* Testimonial/CTA Section */}
      <section className="testimonial-cta">
        <div className="testimonial-content">
          <div className="quote-icon">"</div>
          <p className="testimonial-text">
            I found the perfect cardiologist through this platform. The booking process was 
            seamless and the doctor was extremely knowledgeable.
          </p>
          <div className="testimonial-author">
            <div className="author-rating">
              <FaStar className="star-icon" />
              <FaStar className="star-icon" />
              <FaStar className="star-icon" />
              <FaStar className="star-icon" />
              <FaStar className="star-icon" />
            </div>
            <p className="author-name">- Arvind Kumar Diwakar</p>
          </div>
        </div>
        <button className="cta-button">Book Your Appointment Now</button>
      </section>
    </div>
  );
};

export default DoctorAppointment;